/**
 * Les sons de l'activité, ceux de l'ancien écran, joués par `playStudentSound` (la branche du live ou
 * celle d'avant l'appel) :
 *  - le jingle de fin (`finished.mp3`, `ActivityFinalizedCongrats`), joué à l'ouverture des félicitations ;
 *  - le départ d'une activité neuve (`game-start-cut.mp3`), joué avec son décompte (`TimerActivityStep`) ;
 *  - les deux alertes du chrono (`TimerContainer`) : bientôt la durée prévue (`question_002.mp3`, 95 %),
 *    puis la durée dépassée (`error_003.mp3`, 101 %).
 */
import { type ChronoAlert } from "../../../../../../engine/activity/chrono"

/* eslint-disable @typescript-eslint/no-require-imports */
export const ACTIVITY_SOUNDS = {
    finished: require("../../../../../../../assets/sounds/finished.mp3") as number,
    start: require("../../../../../../../assets/sounds/game-start-cut.mp3") as number,
}

/** Les alertes du chrono, aux seuils de l'ancien (`chronoAlertsAhead`). */
export const CHRONO_ALERT_SOUNDS: Record<ChronoAlert, number> = {
    nearly_due: require("../../../../../../../assets/sounds/question_002.mp3") as number,
    overdue: require("../../../../../../../assets/sounds/error_003.mp3") as number,
}
/* eslint-enable @typescript-eslint/no-require-imports */
